import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { taskHistoryRequest } from '../../store/actions';
import Moment from 'moment';
import { getUser } from 'src/utils/Common';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Paper from "@material-ui/core/Paper";
import ChangeIcon from 'src/components/ChangeIcon';
import ErrorMessage from 'src/components/ErrorMessage';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
    minHeight: 430,
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  divider: {
    backgroundColor: '#1D3343'
  },
  paper: {
    padding: "6px 16px"
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}));

function Tarihce({
  className, ReceiptNo, readonly, tasks, taskHistoryReducer, taskHistoryRequest
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [HistoryItemData, setHistoryItemData] = useState({});
  const SessionUser = getUser();
  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  const isOnline = useSelector((state) => state.status?.isOnline);

  useEffect(() => {
    const HistoryData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
    if (HistoryData.length !== 0) {
      setHistoryItemData(HistoryData[0]);
    } else {
      setHistoryItemData({});
    }
  }, [ReceiptNo, tasks.tasks, readonly]);


  useEffect(() => {
    if (isOnline) {
      taskHistoryRequest(ReceiptNo);
    }
  }, [taskHistoryRequest, ReceiptNo]);

  return (
    <>
      {isOnline ? (
        <>
          {taskHistoryReducer.loading ? (
            <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
          ) : (
            <div />
          )}
          <Timeline align="alternate">

            {taskHistoryReducer.data.map((log, index) =>

              <TimelineItem >
                <TimelineOppositeContent>
                  <Typography variant="body2" color="textSecondary"
                    className={classes.inline}
                    color="textPrimary"
                  >
                    {log.GUN + " " + log.AY.substring(0, 3) + " " + log.YIL + " " + "-" + " " + log.SAAT}

                  </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot color="inherit">
                    <ChangeIcon MobilStatusId={log.MobileStatusId} />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  <Paper elevation={6} className={classes.paper}>
                    <Typography variant="h6" component="h1"
                      className={classes.inline}
                      color="textPrimary"
                    > <h2><b> {log.WorkOrderId + ' - ' + log.DURUM} </b></h2>
                    </Typography>
                    <Typography>
                      <b>{t('islemYapan')}:</b> {log.ISLEM_YAPAN}
                      <br></br>
                      <b>{t('Kullanici')}:</b> {log.KULLANICI}
                      <br></br>
                      <b>{t('lblNote')}:</b> {log.GPSNote}</Typography>
                  </Paper>
                </TimelineContent>

              </TimelineItem>
            )}
          </Timeline>
        </>
      ) : (
        <ErrorMessage message={t('Offline_Message')} />
      )}
    </>

  );

}

Tarihce.propTypes = {
  className: PropTypes.string
};


export default connect(
  (state) => ({
    taskHistoryReducer: state.taskHistoryReducer,
    tasks: state.tasks1,
  }),
  { taskHistoryRequest }
)(Tarihce);
